export default __webpack_public_path__ + "static/media/ovrp-pattern.03076589.png";